import { gql } from '@eti/schema-types';

export const MAKE_ORDER_WITH_BANK_PAYMENT = gql(/* GraphQL */ `
  mutation MakeOrderWithBankPayment(
    $customer: CustomerInput!
    $bank: BankInput!
    $cartId: Long
    $teslaToken: String
  ) {
    makeOrderWithBankPayment(
      customer: $customer
      bank: $bank
      cartId: $cartId
      teslaToken: $teslaToken
    ) {
      success
      type
      message
      redirectURL
      postArgs {
        name
        value
      }
      tripChanges {
        ... on TripPriceChange {
          id
          priceOld {
            price {
              value
            }
          }
          priceNew {
            price {
              value
            }
          }
          priceDiff {
            price {
              value
            }
          }
        }
      }
    }
  }
`);

export const MAKE_ORDER_WITH_CARD_PAYMENT_MUTATION = gql(/* GraphQL */ `
  mutation MakeOrderWithCardPayment(
    $pmopuuid: String!
    $customer: CustomerInput!
    $creditCard: CreditCardInput!
    $encryptedData: String
    $ref: String
    $cartId: Long
    $paymentOptions: PaymentOptionsInput
    $teslaToken: String
    $priceChangeDisplayed: String
    $ubaInfo: UbaInfoInput
  ) {
    makeOrderWithCardPayment(
      pmopuuid: $pmopuuid
      customer: $customer
      creditCard: $creditCard
      encryptedData: $encryptedData
      ref: $ref
      cartId: $cartId
      paymentOptions: $paymentOptions
      teslaToken: $teslaToken
      priceChangeDisplayed: $priceChangeDisplayed
      ubaInfo: $ubaInfo
    ) {
      success
      type
      message
      redirectURL
      postArgs {
        name
        value
      }
      tripChanges {
        ... on TripPriceChange {
          id
          priceOld {
            price {
              value
            }
          }
          priceNew {
            price {
              value
            }
          }
          priceDiff {
            price {
              value
            }
          }
        }
      }
    }
  }
`);

export const MAKE_ORDER_WITH_WALLET_PAYMENT = gql(/* GraphQL */ `
  mutation MakeOrderWithWalletPayment(
    $pmopuuid: String
    $customer: CustomerInput!
    $wallet: WalletInput!
    $cartId: Long
    $teslaToken: String
    $priceChangeDisplayed: String
    $ubaInfo: UbaInfoInput
  ) {
    makeOrderWithWalletPayment(
      pmopuuid: $pmopuuid
      customer: $customer
      wallet: $wallet
      cartId: $cartId
      teslaToken: $teslaToken
      priceChangeDisplayed: $priceChangeDisplayed
      ubaInfo: $ubaInfo
    ) {
      success
      type
      message
      redirectURL
      postArgs {
        name
        value
      }
      tripChanges {
        ... on TripPriceChange {
          id
          priceOld {
            price {
              value
            }
          }
          priceNew {
            price {
              value
            }
          }
          priceDiff {
            price {
              value
            }
          }
        }
      }
    }
  }
`);

export const MAKE_ORDER_WITH_PAY_INTERNAL_PAYMENT = gql(/* GraphQL */ `
  mutation MakeOrderWithPayInternalPayment(
    $pmopuuid: String
    $customer: CustomerInput!
    $cartId: Long
    $teslaToken: String
    $ubaInfo: UbaInfoInput
  ) {
    makeOrderWithPayInternalPayment(
      pmopuuid: $pmopuuid
      customer: $customer
      cartId: $cartId
      teslaToken: $teslaToken
      ubaInfo: $ubaInfo
    ) {
      message
      type
      tripChanges {
        ... on TripPriceChange {
          id
          priceOld {
            price {
              value
            }
          }
          priceNew {
            price {
              value
            }
          }
          priceDiff {
            price {
              value
            }
          }
        }
      }
    }
  }
`);

export const CANCEL_MAKE_ORDER_MUTATION = gql(/* GraphQL */ `
  mutation CancelMakeOrder {
    cancelMakeOrder {
      success
    }
  }
`);

export const REJECT_PRICE_CHANGE = gql(/* GraphQL */ `
  mutation RejectPriceChange {
    rejectPriceChange {
      success
    }
  }
`);

export const STORE_STATISTICS_MUTATION = gql(/* GraphQL */ `
  mutation StoreStatistics(
    $brandedFareOffered: Boolean
    $offeredProducts: [ID!]
    $paymentRequest: Boolean
    $stepIndex: Int
  ) {
    storeStatistics(
      brandedFareOffered: $brandedFareOffered
      offeredProducts: $offeredProducts
      paymentRequest: $paymentRequest
      stepIndex: $stepIndex
    )
  }
`);

export const REMOVE_DISCOUNTS = gql(/* GraphQL */ `
  mutation removeDiscounts {
    removeDiscounts {
      success
    }
  }
`);

export const ADD_DISCOUNT = gql(/* GraphQL */ `
  mutation addDiscountCode($discountCode: String!) {
    addDiscountCode(discountCode: $discountCode) {
      success
      discountPrice {
        price {
          value
        }
      }
      discountErrorMessage {
        headerText
        messages
      }
    }
  }
`);
